<!--首页-->
<template>
	<div class="home_content" id="homeCont">
		<a class="logo" href="https://m.xubei.com/"><img src="/static/images/logo.png" /></a>
		<div class="formTb">
			<div class="combox" v-show="isShowBox">
				<div class="cn">{{ randomli }}</div>
			</div>
			<div class="fblock" v-show="isblock"></div>
			<div class="form-top">
				<div class="form-input">
					<input type="text" class="finput" placeholder="请输入游戏昵称" v-model="username" @blur="blurFun()" />
				</div>
				<div class="form-input" @click="toShow">
					<div class="finput">
						<span>{{ res }}</span>
						<i class="arrow-right"><img src="/static/images/jt.png" /></i>
					</div>
				</div>
			</div>
		</div>
		<div class="submitBtn" @click="submitBtn"><img src="/static/images/next.png" /></div>
		<div class="copyRight"><img src="/static/images/copy_right.png" /></div>
		<div>
			<vue-pickers
				:show="show"
				:columns="columns"
				:defaultData="defaultData"
				:selectData="pickData"
				@cancel="close"
				@confirm="confirmFn"
			></vue-pickers>
		</div>
	</div>
</template>

<script>
import vuePickers from 'vue-pickers';
import { PROXY_URL } from '../../config/env';
import { Toast } from 'mint-ui';
export default {
	name: 'home',
	components: { vuePickers, Toast },
	data: function () {
		return {
			code: this.$route.query.code,
			isShowBox: false,
			isblock: true,
			randomli: '', //随机文案内容
			radomArray: [],
			username: '',
			show: false,
			columns: 1,
			defaultData: [
				{
					id: '',
					text: '',
					value: ''
				}
			],
			pickData: {
				// 第一列的数据结构
				data1: [
					{
						id: '1',
						text: '王者荣耀',
						value: '王者荣耀'
					},
					{
						id: '2',
						text: '英雄联盟',
						value: '英雄联盟'
					},
					{
						id: '3',
						text: '地下城与勇士',
						value: '地下城与勇士'
					},
					{
						id: '4',
						text: '穿越火线',
						value: '穿越火线'
					}
				]
			},
			res: '请选择游戏'
		};
	},
	mounted() {
		var ua = navigator.userAgent.toLowerCase();
		var isWeixin = ua.indexOf('micromessenger') != -1;
		if (isWeixin) {
			if (!this.code) {
				window.location.href =
					'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe5fdc9f33a443b2c&redirect_uri=' +
					window.location.origin +
					'&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
			}

			this.ajax
				.get(PROXY_URL.user + '/h5wx/getH5WxToken?code=' + this.code)
				.then(res => {
					console.log(res.data.result);
					if (res.data.code == 1) {
						this.ajax
							.get(PROXY_URL.user + '/h5wx/getWxUserInfo?token=' + res.data.result)
							.then(data => {
								if (data.data.code == 1) {
									localStorage.setItem('avatar', data.data.result);
								}
							})
							.catch(error => {});
					}
				})
				.catch(error => {});
		}

		this.getRandowList();

		document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
			WeixinJSBridge.call('hideToolbar');
		});
	},
	methods: {
		close() {
			this.show = false;
		},
		confirmFn(val) {
			console.log(val);
			this.show = false;
			for (var i in val) {
				if (val[i].value) {
					this.res = val[i].value;
				}
			}
			this.defaultData = [val.select1];
		},
		toShow() {
			this.show = true;
		},
		blurFun() {
			this.isShowBox = true;
			this.isblock = false;
		},
		getRandowList() {
			this.ajax
				.get(PROXY_URL.config + '/xubei-page-cloud/anon/cms/getModDataByModId?modId=random_wa')
				.then(res => {
					for (var i in res.data.result.datas) {
						this.radomArray.push(res.data.result.datas[i].properties.text);
						var index = Math.floor(Math.random() * this.radomArray.length);
						this.randomli = this.radomArray[index];
					}
				})
				.catch(error => {});
		},
		submitBtn() {
			console.log(this.defaultData);
			console.log(this.defaultData[0].id);

			if (!this.username) {
				Toast('请输入昵称');
				return false;
			}

			if (!this.defaultData[0].value || this.defaultData[0].value == '') {
				Toast('请选择游戏');
				return false;
			}

			if (this.defaultData[0].id == '1') {
				this.$router.push({ path: '/wzry?id=1&username=' + this.username });
			}
			if (this.defaultData[0].id == '2') {
				this.$router.push({ path: '/yxlm?id=2&username=' + this.username });
			}
			if (this.defaultData[0].id == '3') {
				this.$router.push({ path: '/dxcys?id=3&username=' + this.username });
			}
			if (this.defaultData[0].id == '4') {
				this.$router.push({ path: '/cyhx?id=4&username=' + this.username });
			}
		}
	}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.home_content {
	height: 100%;
	width: 10rem;
	margin: 0 auto;
	background: #000 url(/static/images/bg1.jpg) no-repeat;
	background-size: 100% auto;
	.logo {
		padding: px2rem(25rem) 0 0 px2rem(50rem);
		display: block;
		img {
			width: px2rem(278rem);
			height: px2rem(52rem);
		}
	}
	.formTb {
		padding-top: px2rem(460rem);
		.fblock {
			width: 100%;
			height: px2rem(184rem);
		}
		.form-input {
			margin-bottom: px2rem(30rem);
			text-align: center;
			.finput {
				width: px2rem(610rem);
				height: px2rem(90rem);
				line-height: px2rem(90rem);
				background: #34271f;
				color: #ffddb5;
				border-radius: 5px;
				padding: 0 px2rem(15rem);
				margin: 0 auto;
				font-size: px2rem(30rem);
				position: relative;
				text-align: left;
				span {
					color: #ffddb5;
					font-size: px2rem(30rem);
				}
				.arrow-right {
					display: block;
					width: px2rem(39rem);
					height: px2rem(23rem);
					img {
						width: px2rem(39rem);
						height: px2rem(23rem);
						position: absolute;
						right: px2rem(40rem);
						top: px2rem(33.5rem);
					}
				}
			}
		}
	}
	.combox {
		width: px2rem(610rem);
		height: px2rem(130rem);
		margin: 0 auto;
		background: #34271f;
		margin-bottom: px2rem(40rem);
		border-radius: 5px;
		position: relative;
		.cn {
			color: #fff;
			padding: px2rem(25rem);
			font-size: px2rem(32rem);
		}
	}

	.combox:before {
		display: inline-block;
		width: 0;
		height: 0;
		border-width: px2rem(35rem);
		border-style: solid dashed dashed dashed;
		border-color: #34271f transparent transparent transparent;
		content: '';
		position: absolute;
		bottom: px2rem(-56rem);
		right: 50%;
		margin-left: px2rem(17.5rem);
	}

	.submitBtn {
		text-align: center;
		padding-top: px2rem(20rem);
		img {
			width: px2rem(616rem);
			height: px2rem(105rem);
		}
	}
	.copyRight {
		text-align: center;
		margin-top: px2rem(140rem);
		img {
			width: px2rem(419rem);
			height: px2rem(31rem);
		}
	}
}

.btnbox {
	display: flex;
	justify-content: center;
}
.btn {
	background: #2e68fa;
	color: #fff;
	padding: 5px 10px;
	display: inline-block;
	margin: 0 10px;
	font-size: 14px;
	border-radius: 4px;
}
.result {
	text-align: center;
	padding: 10px;
}
.isCopy {
	margin: 10px;
	border: 1px dashed red;
	text-align: center;
}

.home_content /deep/ .area_grid {
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	-webkit-border-image: url(/static/images/dotted.jpg) 30 30 round;
	-o-border-image: url(/static/images/dotted.jpg) 30 30 round;
	border-image: url(/static/images/dotted.jpg) 30 30 round;
}

.home_content /deep/ .area_ctrl {
	font-size: 12px;
	vertical-align: middle;
	background-color: #413c3c;
	color: #fff;
	margin: 0;
	height: auto;
	width: 100%;
	position: fixed;
	width: 100%;
	left: 0;
	bottom: 0;
	z-index: 9901;
	overflow: hidden;
}

.home_content /deep/ .area_btn_box {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: stretch;
	-ms-flex-align: stretch;
	align-items: stretch;
	background-color: #393333;
	position: relative;
}

.home_content /deep/ .tooth {
	color: #fff;
	height: 2em;
	line-height: 2em;
	text-align: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	line-clamp: 1;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	overflow: hidden;
}

.home_content /deep/ .area_btn {
	color: #999;
	font-size: 1.6em;
	line-height: 1em;
	text-align: center;
	padding: 0.8em 1em;
}

.home_content /deep/ .larea_finish {
	color: #ffddb5;
}

.home_content /deep/ .area_btn_box:before,
.home_content /deep/ .area_btn_box:after {
	content: '';
	position: absolute;
	height: 1px;
	width: 100%;
	display: block;
	background-color: transparent;
	z-index: 15;
	-webkit-transform: scaleY(0.33);
	transform: scaleY(0.33);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue